// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestedUserCard-cls1___f88e95b0c637bc5a734","cls2":"SuggestedUserCard-cls2___8172ca5a89e3f0a482d SuggestedUserCard-cls1___f88e95b0c637bc5a734"};